import { NativeAssetInfo } from "./assetInfo";
export class AssetAmount {
    constructor(asset, amount) {
        this.asset = asset;
        this.amount = amount;
    }
    static fromToken(token) {
        return new this({
            id: token.tokenId,
            name: token.name,
            decimals: token.decimals
        }, token.amount);
    }
    static native(amount) {
        return new this(NativeAssetInfo, amount);
    }
    withAmount(amount) {
        return new AssetAmount(this.asset, amount);
    }
    toToken() {
        return { tokenId: this.asset.id, amount: this.amount };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXRBbW91bnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZW50aXRpZXMvYXNzZXRBbW91bnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFZLGVBQWUsRUFBQyxNQUFNLGFBQWEsQ0FBQTtBQUd0RCxNQUFNLE9BQU8sV0FBVztJQUN0QixZQUE0QixLQUFnQixFQUFrQixNQUFjO1FBQWhELFVBQUssR0FBTCxLQUFLLENBQVc7UUFBa0IsV0FBTSxHQUFOLE1BQU0sQ0FBUTtJQUFHLENBQUM7SUFFaEYsTUFBTSxDQUFDLFNBQVMsQ0FBQyxLQUFrQjtRQUNqQyxPQUFPLElBQUksSUFBSSxDQUNiO1lBQ0UsRUFBRSxFQUFFLEtBQUssQ0FBQyxPQUFPO1lBQ2pCLElBQUksRUFBRSxLQUFLLENBQUMsSUFBSTtZQUNoQixRQUFRLEVBQUUsS0FBSyxDQUFDLFFBQVE7U0FDekIsRUFDRCxLQUFLLENBQUMsTUFBTSxDQUNiLENBQUE7SUFDSCxDQUFDO0lBRUQsTUFBTSxDQUFDLE1BQU0sQ0FBQyxNQUFjO1FBQzFCLE9BQU8sSUFBSSxJQUFJLENBQUMsZUFBZSxFQUFFLE1BQU0sQ0FBQyxDQUFBO0lBQzFDLENBQUM7SUFFRCxVQUFVLENBQUMsTUFBYztRQUN2QixPQUFPLElBQUksV0FBVyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFDNUMsQ0FBQztJQUVELE9BQU87UUFDTCxPQUFPLEVBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxFQUFFLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxFQUFDLENBQUE7SUFDdEQsQ0FBQztDQUNGIn0=